var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysGalleryFilled = function SvgSysGalleryFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sysGalleryFilled_svg__b{fill:currentColor}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.798 13.512V4.576a1.435 1.435 0 0 0-1.431-1.431H2.431A1.435 1.435 0 0 0 1 4.576v8.939a1.435 1.435 0 0 0 1.431 1.431h8.939a1.439 1.439 0 0 0 1.428-1.434ZM4.663 9.58l1.518 2.145 2.236-3.218 2.95 4.29H2.431Z",
    className: "sysGalleryFilled_svg__b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.512 1H4.576a1.435 1.435 0 0 0-1.431 1.431v.178h8.758a1.435 1.435 0 0 1 1.431 1.431v8.758h.178a1.435 1.435 0 0 0 1.431-1.431V2.431A1.435 1.435 0 0 0 13.512 1Z",
    className: "sysGalleryFilled_svg__b"
  })));
};
export default SvgSysGalleryFilled;